import { Children, useRef } from 'react';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';

import { IconButton } from '../../cdl/IconButton/IconButton';
import { CheapIndicator } from '../../common/CheapIndicator/CheapIndicator';
import { IconChevronLeft } from '../../common/icons/cdl/ChevronLeft';
import { IconChevronRight } from '../../common/icons/cdl/ChevronRight';
import { CloakBox } from '../../common/Slider/CloakBox';
import { Box } from '../../common/ui/Box';

import { LoadingPriceBox } from './LoadingPriceBox';

export const SupplierPriceSlider = ({ slidesPerView, isFetching, children, onSlideChange, cheapestDefaultScope }) => {
    const prevSlideControl = useRef(null);
    const nextSlideControl = useRef(null);

    return (
        <Box position="relative" paddingX={64}>
            <CloakBox left="0">
                {cheapestDefaultScope.prev ? <CheapIndicator left="-10px" /> : null}
                <IconButton type="button" Icon={IconChevronLeft} emphasis="medium" ref={prevSlideControl} />
            </CloakBox>
            <CloakBox right="0" reverseGradient>
                {cheapestDefaultScope.next ? <CheapIndicator right="-10px" /> : null}
                <IconButton type="button" Icon={IconChevronRight} emphasis="medium" ref={nextSlideControl} />
            </CloakBox>

            <Box>
                <Swiper
                    modules={[Navigation]}
                    slidesPerView={slidesPerView}
                    spaceBetween={24}
                    slidesPerGroup={2}
                    loop={false}
                    navigation={{
                        prevEl: prevSlideControl.current,
                        nextEl: nextSlideControl.current,
                    }}
                    onSlideChange={(swiper) => {
                        onSlideChange(swiper.realIndex);
                    }}
                    style={{ padding: '20px 20px' }}
                >
                    {isFetching
                        ? Array.from(Array(slidesPerView).keys()).map((index) => {
                              return (
                                  <SwiperSlide key={`loading-slide-${index}`}>
                                      <Box display="flex" key={index} width="100%" justifyContent="center">
                                          <LoadingPriceBox />
                                      </Box>
                                  </SwiperSlide>
                              );
                          })
                        : Children.map(children, (child, index) => {
                              return <SwiperSlide key={index}>{child}</SwiperSlide>;
                          })}
                </Swiper>
            </Box>
        </Box>
    );
};
